import { JobNumberingScheme, JobNumberingSettings, SaveJobNumberingSettingsRequest } from '../../../domain/jobs/jobNumbering'

export type JobNumberingFormValues = {
  scheme: JobNumberingScheme
  prefix: string
  includeYear: boolean
  digits: number
  nextNumber: number
}

export const toJobNumberingFormValues = (settings: JobNumberingSettings): JobNumberingFormValues => ({
  scheme: settings.scheme,
  prefix: settings.prefix ?? '',
  includeYear: settings.includeYear,
  digits: settings.digits,
  nextNumber: settings.nextNumber,
})

export const toSaveJobNumberingSettingsRequest = (
  values: JobNumberingFormValues,
  saved: JobNumberingSettings
): SaveJobNumberingSettingsRequest => ({
  scheme: values.scheme,
  prefix: values.prefix.trim() === '' ? null : values.prefix.trim(),
  includeYear: values.includeYear,
  digits: values.digits,
  nextNumber: values.scheme === 'company' && values.nextNumber !== saved.nextNumber ? values.nextNumber : null,
})
